module.exports = __webpack_public_path__ + "front/img/82.ae82a81a.png";